import React from 'react';
import HeroSplit from '../components/sections/HeroSplit';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesTabs from '../components/sections/FeaturesTabs';
import News from '../components/sections/News';
import Pricing from '../components/sections/Pricing';

class Home extends React.Component {
  pricingRef = React.createRef();

  componentDidMount() {
    this.scrollForHash();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location?.state !== prevProps.location?.state || this.props.location?.hash !== prevProps.location?.hash) this.scrollForHash();
  }

  scrollForHash = () => {
    if (this.props.location?.state?.scrollTarget === 'pricing' || (this.props.location?.hash || window.location.hash) === '#pricing') {
      this.pricingFrame = window.requestAnimationFrame(() => this.scrollToPricing());
    }
  };

  componentWillUnmount() {
    window.cancelAnimationFrame(this.pricingFrame);
  }

  scrollToPricing = () => {
    if (this.pricingRef.current) {
      this.pricingRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  render() {
    return (
      <>
        <HeroSplit hasBgColor invertColor onPricingClick={this.scrollToPricing} />
        <FeaturesTiles />
        <FeaturesTabs topDivider bottomOuterDivider />
        <News className="illustration-section-01" />

        <div ref={this.pricingRef}>
          <Pricing hasBgColor pricingSlider />
        </div>
      </>
    );
  }
}

export default Home;
